/**
 * Extract error message from API error response
 * Handles cases where error.detail might be an object or string
 */
export const getErrorMessage = (error, fallback = 'Bir hata olustu.') => {
  try {
    const detail = error.response?.data?.detail;
    
    if (!detail) {
      return fallback;
    }
    
    // If detail is an array (validation errors from FastAPI)
    if (Array.isArray(detail)) {
      return detail.map(err => {
        if (typeof err === 'object' && err.msg) {
          return `${err.loc ? err.loc.join('.') + ': ' : ''}${err.msg}`;
        }
        return JSON.stringify(err);
      }).join(', ');
    }
    
    // If detail is an object
    if (typeof detail === 'object') {
      if (detail.msg) return detail.msg;
      return JSON.stringify(detail);
    }
    
    // If detail is a string
    return detail;
  } catch (e) {
    console.error('Error parsing error message:', e);
    return fallback;
  }
};
